import { render, staticRenderFns } from "./AnularBase.vue?vue&type=template&id=1d8bf9cd"
import script from "./AnularBase.vue?vue&type=script&lang=js"
export * from "./AnularBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports